import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=659bd96c&scoped=true&"
import script from "./contactList.vue?vue&type=script&lang=js&"
export * from "./contactList.vue?vue&type=script&lang=js&"
import style0 from "./contactList.vue?vue&type=style&index=0&id=659bd96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659bd96c",
  null
  
)

export default component.exports